export const CLASS_DETAIL_STUDENT_PAGE_SIZE = 10

export function getClassStudentPageCount(totalStudents: number, pageSize = CLASS_DETAIL_STUDENT_PAGE_SIZE) {
  if (totalStudents <= 0) return 0
  return Math.ceil(totalStudents / pageSize)
}

export function clampClassStudentPage(
  requestedPage: number,
  totalStudents: number,
  pageSize = CLASS_DETAIL_STUDENT_PAGE_SIZE,
) {
  const pageCount = getClassStudentPageCount(totalStudents, pageSize)
  if (pageCount === 0) return 0
  return Math.min(Math.max(requestedPage, 0), pageCount - 1)
}

export function getPaginatedClassStudents<T>(
  students: T[],
  currentPage: number,
  pageSize = CLASS_DETAIL_STUDENT_PAGE_SIZE,
) {
  const safePage = clampClassStudentPage(currentPage, students.length, pageSize)
  const start = safePage * pageSize
  return students.slice(start, start + pageSize)
}

export function shouldShowClassStudentPagination(
  totalStudents: number,
  pageSize = CLASS_DETAIL_STUDENT_PAGE_SIZE,
) {
  return totalStudents > pageSize
}

export function buildClassStudentPageNumbers(
  totalPages: number,
  currentPage: number,
): Array<number | 'ellipsis'> {
  const pageNumbers: Array<number | 'ellipsis'> = []

  if (totalPages <= 7) {
    for (let index = 0; index < totalPages; index += 1) {
      pageNumbers.push(index)
    }
    return pageNumbers
  }

  pageNumbers.push(0)
  if (currentPage > 2) pageNumbers.push('ellipsis')

  const start = Math.max(1, currentPage - 1)
  const end = Math.min(totalPages - 2, currentPage + 1)
  for (let index = start; index <= end; index += 1) {
    pageNumbers.push(index)
  }

  if (currentPage < totalPages - 3) pageNumbers.push('ellipsis')
  pageNumbers.push(totalPages - 1)

  return pageNumbers
}
